enum FORM_NAMES {
  junior = 'junior',
  middle = 'middle',
  senior = 'senior',
  others = 'others',
  numberOfGuests = 'number_of_guests',
  numberOfPets = 'number_of_pets',
  group_type = 'group_type',
  guests = 'guests',
}

enum MODAL_FORMS {
  numberOfGuests = 'number_of_guests',
  reservationType = 'reservation_type',
  confirmLeaderGuest = 'confirm_leader_guest',
}

const COUNTER_ROW_CLASS = 'rounded-2xl bg-[var(--chekin-color-white)] px-4 py-3';
const COUNTER_GROUPED_ROW_CLASS = 'py-3';
const COUNTER_GROUP_CLASS =
  'divide-y divide-[var(--chekin-divider-subtle)] rounded-[18px] bg-[var(--chekin-color-surface-pressed)] px-4 py-1';
const COUNTER_FORM_DOCK_CLASS = 'mt-2 px-0 [--cta-dock-elevated-shadow:none]';

export {
  FORM_NAMES,
  MODAL_FORMS,
  COUNTER_FORM_DOCK_CLASS,
  COUNTER_GROUP_CLASS,
  COUNTER_GROUPED_ROW_CLASS,
  COUNTER_ROW_CLASS,
};
